import { MutationTree } from 'vuex'
import { TrailState } from './types'
import Vue from 'vue'
export const mutations: MutationTree<TrailState> = {
  clearThingTrailLocations(state) {
    state.trailLocations = []
  },
  nextPageTrailLocation(state) {
    state.thingPage = state.thingPage + 1
  },
  emptyTrailLocations(state) {
    state.trailLocations = []
  },
  highlightMarker(state, id) {
    state.markerHighlighted = id
    //Reseteo el estado luego de 100ms
    setTimeout(() => {
      state.markerHighlighted = -1
    }, 100)
  },
  setThingTrail(state, thing) {
    state.thing = thing
  },
  setThingTrailLocations(state, arrayTrail) {
    state.trailLocations.push(...arrayTrail)
  },
  setBoundsLocations(state, latLngBound) {
    state.boundsLocations.extend(latLngBound)
  },
  setTrailLocationByPage(state, payload) {
    if (!Boolean(state.lastPointTrailLocations)) {
      state.trailLocationByPage = payload.arrayTrails
    } else {
      if (state.thingPage > 1 && !payload.resettingTrails) {
        state.trailLocationByPage = [
          state.lastPointTrailLocations,
          ...payload.arrayTrails
        ]
      } else {
        state.trailLocationByPage = payload.arrayTrails
      }
    }
    if (payload.arrayTrails.length === 1000) {
      const lastPoint = payload.arrayTrails[payload.arrayTrails.length - 1]
      state.lastPointTrailLocations = lastPoint
    } else {
      state.lastPointTrailLocations = null
    }
  },
  clearTrailArr(state) {
    //Remuevo linea seteada previamente en el mapa
    if (state.trailArr.length > 0) {
      state.trailArr.map(function(trail) {
        trail.setMap(null)
      })
      state.trailArr.splice(0)
    }
  },
  setLocations(state, locations) {
    state.locations.push(locations)
  },
  setLocationsWithEvents(state, { data, marker }) {
    state.locationsWithEvents.push({ data, marker })
  },
  removeLocationsAndEvents(state) {
    if (state.locations.length > 0) {
      state.locations.map(function(marker) {
        marker.setMap(null)
      })
      state.locations.splice(0)
      state.locationsWithEvents.splice(0)
    }
  },
  pushTrailArr(state, trailArr) {
    state.trailArr.push(trailArr)
  },
  setThingTrailSummary(state, { thingTrailSummaryData }) {
    state.thingTrailSummary = thingTrailSummaryData
  },
  setGeoReference(state, payload) {
    // Se verifica que no sea undefined ya que si se cierra el componente
    // cuando aún esta en proceso la georeferencia, arroja error
    if (typeof state.trailLocations[payload.id - 1] !== 'undefined')
      Vue.set(
        state.trailLocations[payload.id - 1],
        'geoReference',
        payload.geoReference
      )
  },
  setDataLoading(state, value) {
    state.dataLoading = value
  },
  setDataGeoreferenceLoading(state, { loading }) {
    state.dataGeoreferenceLoading = loading
  },
  setQueryTimestamp(state, timestamp) {
    state.queryTimestamp = timestamp
  },
  toggleShowEvents(state, value) {
    state.showEvents = value
  },
  setFilterActive(state, value) {
    state.filterActive = value
  },
  setTrailLocation(state, { geoReference }) {
    state.geoReference.push(geoReference)
  },
  setTotalDistanceInZero(state) {
    state.totalDistance = 0
  },
  setTotalDistance(state, { partialDistance }) {
    state.totalDistance += partialDistance
  },
  setPrevNonNullOdometer(state, { odometer }) {
    state.prevNonNullOdometer = odometer
  },
  setPrevOdometerInNull(state) {
    state.prevNonNullOdometer = null
  },
  setThingGpsID(state, { gpsID }) {
    state.thingGpsID = gpsID
  },
  clearThingGpsID(state) {
    state.thingGpsID = ''
  },
  setPrevNonNullCandata(state, { candata }) {
    state.prevNonNullCandata = candata
  },
  setPrevNonNullIgntitionStatus(state, { ignitionStatus }) {
    state.prevNonNullIgnitionStatus = ignitionStatus
  },
  setPrevNonNullMainPowerOn(state, { mainPowerOn }) {
    state.prevNonNullMainPowerOn = mainPowerOn
  },
  setTotalOdoliterInZero(state) {
    state.totalOdoliter = 0
  },
  setTotalOdoliter(state, { partialOdoliter }) {
    state.totalOdoliter += partialOdoliter
  },
  setPrevTelemetryInNull(state) {
    state.prevNonNullCandata = null
  },
  setHideGreeting(state, { hideGreeting }) {
    state.hideGreeting = hideGreeting
  }
}
